import request from '@/utils/request'

function reportSoundActivity() {
  if (!localStorage.getItem('token')) return
  request.post('/api/ajax_set_sound', {}).catch(() => {})
}

class SoundManager {

  constructor() {

    this.audios = {
      '105': new Audio('/sounds/notify.mp3'),
      '36': new Audio('/sounds/notify1.mp3')
    };
    const saved = localStorage.getItem(
      'app_sound_muted'
    );
    this.muted = saved === '1';

    this.unlocked = false;
    this.queue = [];
    this.isPlaying = false;
    this._lastForcePlay = null;

  }

  // 每次用户交互时尝试解锁（浏览器可能在一段时间后挂起 AudioContext）
  unlock() {
    if (this.muted) {
      this.unlocked = true;
      console.log('🔓 音频已解锁（当前静音）');
      return Promise.resolve(true);
    }

    const wasUnlocked = this.unlocked;

    const tasks = Object.values(this.audios).map(audio => {
      audio.muted = true;
      return audio.play()
        .then(() => {
          audio.pause();
          audio.currentTime = 0;
          audio.muted = this.muted;
          return true;
        })
        .catch(() => false);
    });

    return Promise.all(tasks).then((results) => {
      const success = results.some(Boolean);
      if (success) {
        this.unlocked = true;
        if (!wasUnlocked) {
          console.log('🔓 音频已解锁');
        }
        return true;
      }
      this.unlocked = false;
      console.log('🔒 音频解锁失败，请点击页面任意位置');
      return false;
    });
  }

  play(type = '36') {
    if (this.muted) return Promise.resolve(true);
    if (!this.unlocked) return Promise.resolve(false);

    return new Promise((resolve) => {
      this.queue.push({ type, resolve });
      this.processQueue();
    });
  }

  // 后台标签页时部分浏览器对复用 Audio 限制更严，用新实例尝试播放
  playForce(type = '36') {
    if (this.muted) return Promise.resolve(true);
    if (!this.unlocked) return Promise.resolve(false);

    const now = Date.now();
    if (
      this._lastForcePlay &&
      this._lastForcePlay.type === type &&
      now - this._lastForcePlay.time < 3000
    ) {
      return Promise.resolve(true);
    }

    const src = type === '105' ? '/sounds/notify.mp3' : '/sounds/notify1.mp3';
    const audio = new Audio(src);

    return audio.play()
      .then(() => {
        this._lastForcePlay = { type, time: Date.now() };
        console.log('🔊 后台标签页铃声已播放');
        return true;
      })
      .catch((err) => {
        console.warn('后台铃声播放失败:', err);
        return false;
      });
  }

  async processQueue() {
    if (this.isPlaying) return;
    if (!this.queue.length) return;

    this.isPlaying = true;
    const { type, resolve } = this.queue.shift();
    const audio = this.audios[type];

    if (!audio) {
      resolve(false);
      this.isPlaying = false;
      this.processQueue();
      return;
    }

    try {
      audio.pause();
      audio.currentTime = 0;

      await audio.play();
      await new Promise(r => {
        audio.onended = r;
      });
      resolve(true);
    } catch (err) {
      console.warn('播放失败:', err);
      this.unlocked = false;
      resolve(false);
    } finally {
      this.isPlaying = false;
      this.processQueue();
    }
  }

  setMuted(val) {
    this.muted = val;
    localStorage.setItem(
      'app_sound_muted',
      val ? '1' : '0'
    );

    Object.values(this.audios).forEach(audio => {
      audio.muted = val;
      if (val) {
        audio.pause();
        audio.currentTime = 0;
      }
    });

    if (val) {
      this.queue = [];
      this.isPlaying = false;
    }

    reportSoundActivity()
  }

  toggle() {
    this.setMuted(!this.muted);
    return this.muted;
  }

  isMuted() {
    return this.muted;
  }

  isUnlocked() {
    return this.unlocked;
  }
}

export default new SoundManager();
